import React from 'react';
import CookieConsent, {Cookies} from "react-cookie-consent";

const CookieConsentBar = () => {
    return (
        <CookieConsent
            buttonText="Accept"
            declineButtonText="Decline"
            enableDeclineButton={true}
            flipButtons={true}
            style={{background: '#414042'}}
            buttonStyle={{background: '#ee2737', color: "white"}}
            declineButtonStyle={{background: '#ee2737', color: "white"}}
        >
            <h1 className="cookie__txt"> We use cookies to ensure that we give you the best experience on our website.
                If you continue to use this site we will assume that you are happy with it..</h1>
        </CookieConsent>

    );
};

export default CookieConsentBar;
